import apiClient from './apiClient';
import {
  DbServer,
  DbConnection,
  CreateDbServerRequest,
  CreateDbConnectionRequest,
} from '../types/registry';

const BASE_SERVERS = '/api/v1/db-servers';
const BASE_CONNECTIONS = '/api/v1/db-connections';

export const registryService = {
  // ─── Servers ───────────────────────────────────────────────
  getServers: async (all = false): Promise<DbServer[]> =>
    apiClient.get<DbServer[]>(`${BASE_SERVERS}?all=${all}`),

  getServersByType: async (serverType: string): Promise<DbServer[]> =>
    apiClient.get<DbServer[]>(`${BASE_SERVERS}?serverType=${serverType}`),

  getServer: async (id: string): Promise<DbServer> =>
    apiClient.get<DbServer>(`${BASE_SERVERS}/${id}`),

  createServer: async (request: CreateDbServerRequest): Promise<DbServer> =>
    apiClient.post<DbServer>(BASE_SERVERS, request),

  updateServer: async (id: string, request: CreateDbServerRequest): Promise<DbServer> =>
    apiClient.put<DbServer>(`${BASE_SERVERS}/${id}`, request),

  disableServer: async (id: string): Promise<void> =>
    apiClient.delete(`${BASE_SERVERS}/${id}`),

  // ─── Connections ───────────────────────────────────────────
  getConnections: async (all = false): Promise<DbConnection[]> =>
    apiClient.get<DbConnection[]>(`${BASE_CONNECTIONS}?all=${all}`),

  getConnectionsByServer: async (serverId: string): Promise<DbConnection[]> =>
    apiClient.get<DbConnection[]>(`${BASE_CONNECTIONS}?serverId=${serverId}`),

  getConnection: async (id: string): Promise<DbConnection> =>
    apiClient.get<DbConnection>(`${BASE_CONNECTIONS}/${id}`),

  createConnection: async (request: CreateDbConnectionRequest): Promise<DbConnection> =>
    apiClient.post<DbConnection>(BASE_CONNECTIONS, request),

  updateConnection: async (id: string, request: CreateDbConnectionRequest): Promise<DbConnection> =>
    apiClient.put<DbConnection>(`${BASE_CONNECTIONS}/${id}`, request),

  disableConnection: async (id: string): Promise<void> =>
    apiClient.delete(`${BASE_CONNECTIONS}/${id}`),

  activateConnection: async (id: string): Promise<void> =>
    apiClient.post(`${BASE_CONNECTIONS}/${id}/activate`, {}),
};
